import { TaskTemplate } from "@hg/recall-frame"

export const TASK_TEMPLATE_MAP = {
    [TaskTemplate.SHARE]: {
        introduction: "task.share",
        reward_1_key: "lmb",
        reward_1_amount: 5000,
        reward_2_key: "chance",
        reward_2_amount: 0,
    },
    [TaskTemplate.CASUAL]: {
        introduction: "task.casual",
        reward_1_key: "hcy",
        reward_1_amount: 100,
        reward_2_key: "chance",
        reward_2_amount: 0,
    },
    [TaskTemplate.INVITE]: {
        introduction: "task.invite",
        reward_1_key: "hcy",
        reward_1_amount: 200,
        reward_2_key: "chance",
        reward_2_amount: 1,
    },
    [TaskTemplate.MEMBER_LOGIN_TIMES]: {
        introduction: "task.member_login_times",
        reward_1_key: "hcy",
        reward_1_amount: 300,
        reward_2_key: "chance",
        reward_2_amount: 2,
    },
} as const
